import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalFooter,
  Button,
  UseDisclosureReturn,
} from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';

interface ModalBuyModuleProps {
  modalHabilitar: UseDisclosureReturn;
}

export const ModalBuyModule: React.FC<ModalBuyModuleProps> = ({ modalHabilitar }) => {
  const primaryColor = '#38A169'; // Green color used in the codebase

  return (
    <Modal isOpen={modalHabilitar.isOpen} onClose={modalHabilitar.onClose}>
      <ModalOverlay />
      <ModalContent borderRadius="20px">
        <ModalHeader>Habilitar Produto</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          Olá! Para habilitar este produto, entre em contato com a equipe Partiu. Será um prazer auxiliá-lo(a) nesse processo e garantir a melhor experiência para você.
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={modalHabilitar.onClose}>
            Fechar
          </Button>
          <Button
            _hover={{ backgroundColor: primaryColor }}
            color="white"
            gap="10px"
            onClick={() => {
              window.open(
                'https://api.whatsapp.com/send?phone=5511940300996&text=Olá, gostaria de falar com a Partiu!, quero contratar um módulo',
                '_blank'
              );
            }}
            backgroundColor={primaryColor}
            variant="ghost"
          >
            <FaWhatsapp />
            Abrir WhatsApp
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};



